import { createTheme } from "@mui/material";

const theme = createTheme({
    palette: {
        primary: {
            main : "#333"
        },
        secondary: {
            main : "#fff"
        }
    }
});

export default theme;
